<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <h2>平台结算金</h2>
      <div style="display: flex; padding-bottom: 24px">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="record-item item-t"
        >
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" style="padding-bottom: 24px !important">
      <h2>结算金管理</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="search"
          class="search-form"
          size="small"
        >
          <el-form-item label="五域商品编号" prop="goodsNo">
            <el-input
              v-model="searchForm.goodsNo"
              placeholder="请输入五域商品编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input
              v-model="searchForm.goodsName"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="上架时间" prop="upTimeStart">
            <el-date-picker
              style="width: 215px"
              v-model="upTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" :loading="exporting" @click="exportFn"
            >导出</el-button
          >
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
// import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable,
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '平台结算金', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {

          title: '结算金总额',
          price: '10000'
        },
        {

          title: '待结算金额',
          price: '10000'
        },
        {

          title: '可提现金额',
          price: '10000'
        },
        {

          title: '已提现金额',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '平台结算金', path: '', type: '0' }
        ]
      },
      list: [],
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '商品信息',
          minWidth: '220',
          render: (h, scope) => {
            return (
              <div style="display:flex;align-items:center">
                <el-image src={scope.row.goodsImage} preview-src-list={[scope.row.goodsImage]} lazy style="width:64px;height:64px;"></el-image>
                <div style="display:flex:justify-content:space-between;font-size:14px;margin-left:8px;flex:1;">
                  <p style="width:100%;text-align:left;">{scope.row.goodsName}</p>
                  <p style="color:#606066;text-align:left;">平台商品编号：{scope.row.psGoodsNo}</p>
                </div>
              </div>
            )
          }
        },
        { label: '五域商品编号', prop: 'goodsNo', width: '150' },
        { label: '上架时间', prop: 'upTime', width: '220' },
        {
          label: '成本价（元）', prop: 'categoryName', width: '120',
          render: (h, scope) => {
            return (
              <div>{scope.row.minCostPrice} - {scope.row.maxCostPrice}</div>
            )
          }
        },
        { label: '平台销售数量', prop: 'platformSoldNum' },
        { label: '五域销售数量', prop: 'wySoldNum' },
        { label: '销售总数量', prop: 'totalSoldNum', },
        { label: '待结算金额（元）', prop: 'awaitSettleAmount', width: '150' },
        { label: '结算金额（元）', prop: 'settledAmount', width: '150' },
        {
          label: '操作',
          width: '90',
          align: 'center',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.toOtherPages(scope.row) }}>详情</span>
              </div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false,
      searchForm: {
        goodsName: '',
        goodsNo: '',
        upTimeStart: '',
        upTimeEnd: '',
        platformId: '',
        pageNo: 1,
        pageSize: 10
      },
      platformId: null,
      upTime: []
    }
  },
  created () {
    this.platformId = this.$route.query.platformId
    this.searchForm.platformId = this.$route.query.platformId
    this.getStatistics()
    this.getPageList()
  },
  methods: {
    exportFn () {
      // this.$router.push({
      //           name:'platformSettlementFundDetail'
      //       })
      //       return
      if (this.upTime && this.upTime.length > 0) {
        this.searchForm.upTimeStart = this.upTime[0];
        this.searchForm.upTimeEnd = this.upTime[1];
      } else {
        this.searchForm.upTimeStart = '';
        this.searchForm.upTimeEnd = '';
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.exporting = true;
      this.axios.post('/ps/platforms/settlement/goodsExport', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData (type) {
      this.page.pageNo = 1;
      if (type == 'search') {

      } else {
        this.upTime = []
        this.$refs['search'].resetFields()
      }
      this.getPageList()
    },
    getPageList () {
      console.log(this.upTime)
      if (this.upTime && this.upTime.length > 0) {
        this.searchForm.upTimeStart = this.upTime[0];
        this.searchForm.upTimeEnd = this.upTime[1];
      } else {
        this.searchForm.upTimeStart = '';
        this.searchForm.upTimeEnd = '';
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/ps/platforms/settlement/goodsList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              item.awaitSettleAmount = item.awaitSettleAmount.toFixed(2)
              item.settledAmount = item.settledAmount.toFixed(2)
              item.maxCostPrice = item.maxCostPrice.toFixed(2)
              item.minCostPrice = item.minCostPrice.toFixed(2)
            });
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection (e) { },
    handleSizeChange (e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList();
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getPageList();
    },
    getStatistics () {
      this.axios.get('/ps/platforms/settlement/statistics?platformId=' + this.platformId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.totalMoney;
            this.records[1].price = res.data.awaitMoney;
            this.records[3].price = res.data.paidMoney;
            this.records[2].price = res.data.activeMoney;
          }
        })
    },
    toOtherPages (row) {
      this.$router.push({
        name: 'platformSettlementFundDetail',
        query: {
          platformId: this.platformId,
          goodsId: row.goodsId
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  width: 270px;
  height: 88px;
  background: #f2f5ff;
  opacity: 1;
  border-radius: 4px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }

    .title {
      // width: 56px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 20px;
      color: #333333;
      opacity: 1;
      margin-left: 20px;
      // margin-top: 18px;
    }

    .price {
      // width: 103px;
      height: 25px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 25px;
      color: #4168e7;
      opacity: 1;
      margin-left: 20px;
      margin-top: 8px;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>

